module.exports = __webpack_public_path__ + "static/pub_modal.0a440709.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/featIllos/pub_modal.svg
// module id = 1101
// module chunks = 35783957827783